import { get } from 'lodash';

export default async (context, inject) => {
  const { app, $axios, $config } = context;

  const buildRequest = async ({ $axios, $config }) => {
      const host = window.location.hostname;

      const parts = host.split('.');
      const subdomain = parts[0] || 'app';

      const request = {
        application: 'fachkraefteradar',
        body: {
          name: '',
          color: '#ee5e24' } };

      try {
        // @ts-ignore
        const axios = $axios.create({});
        axios.setBaseURL($config.API_URL);
        const tenant = (await axios.get(`/v1/tenants?filter[slug]=${subdomain}`))?.data?.data[0];

        request.body.name = tenant.name;
        request.body.color = tenant.color;
      } catch (e) {}

      return request;
    };

  const request = await buildRequest(context);

  const apiUrl = get($config, 'WEBMANIFEST_API_URL');

  try {
    const headConfiguration = await $axios.post(`${apiUrl}/v1/heads/${request.application}`, request.body);

    const { link, meta } = app.head;

    link.push({
      hid: 'manifest',
      rel: 'manifest',
      href: headConfiguration.data.manifest_url,
    });
    link.push({
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: headConfiguration.data.favicon_url,
    });
    meta.push({
      hid: 'theme-color',
      name: 'theme_color',
      content: headConfiguration.data.theme_color,
    });
  } catch (e) {
  }
};
